import * as THREE from 'three';
import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

export const CameraWrapper = ({ modelRef }) => {
  const vector = new THREE.Vector3(0, 0, 0);
  const { camera } = useThree();

  useEffect(() => {
    if (modelRef.current) {
      vector.set(camera.position.x - modelRef.current.position.x, camera.position.y - modelRef.current.position.y, camera.position.z - modelRef.current.position.z);
      // console.log('Camera to Model Vector:', vector);
    }
  }, [camera.position, modelRef]);

  return null;
};
